<template>
  <v-dialog v-model="loading" hide-overlay persistent width="300">
    <v-card color="primary" dark>
      <v-container grid-list-lg>
        {{ text ? text : 'Please Stand By' }}
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "loading-dialog",
  props: ["loading", "text"],
};
</script>
